import React, { useCallback, useState } from 'react';
import { RowWrapper, Td } from './styles';

const TableRow = ({
  id,
  item,
  fieldsArray,
  fields,
  arrayKey,
  rowStyle,
  onRowClick,
  onTdClick,
  getWidth,
  getStyle,
  hover,
}) => {
  const [hovered, setHovered] = useState(false);

  const onMouseEnter = useCallback(() => {
    setHovered(true);
  }, []);

  const onMouseLeave = useCallback(() => {
    setHovered(false);
  }, []);

  return (
    <RowWrapper
      id={id}
      style={rowStyle}
      hover={hover && hovered}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={() => onRowClick(item, arrayKey)}
    >
      {fieldsArray.map((key, index) => (
        <Td
          onClick={() => onTdClick(item, fields, key, arrayKey)}
          className={fields[key].className ? fields[key].className : ''}
          align={fields[key].align ? fields[key].align : ''}
          key={index}
          style={getStyle(fields[key], key)}
          flexWidth={getWidth(fields[key])}
        >
          {fields[key].field(item, arrayKey)}
        </Td>
      ))}
    </RowWrapper>
  );
};

export default TableRow;
